export default "/assets/images/book-shell.png?3a7b3994144ba3769f86b6c0bed2c393";